import { render, staticRenderFns } from "./FundMessageThread.vue?vue&type=template&id=2ff02d12&"
import script from "./FundMessageThread.vue?vue&type=script&lang=ts&"
export * from "./FundMessageThread.vue?vue&type=script&lang=ts&"
import style0 from "./FundMessageThread.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports